export enum ReviewStatus {
    APPROVE = "1",
    REQUEST_CHANGES = "2"
}